import React, {Component} from 'react';
import {Col, Row} from "react-bootstrap";
import {TopButtonPointEdit} from "../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import Viewer from 'react-viewer';
import 'react-viewer/dist/index.css';
import {TopAlertInformacja} from "../../../../componentsTopsa/alerty/TopAlerts";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import moment from "moment";
import DownloadUtilities from "../../../../utilities/DownloadUtilities";
import OthersUtilities from "../../../../utilities/othersUtilities/OthersUtilities";
import WyslijMailDoKlientaPopup from "../../../komunikaty/powiadomienia/external_component/WyslijMailDoKlientaPopup";

export default class StronaKlientaDane extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            documents: [],
            visible: false,
            pokazPopupWyslijEmail: false,
            adresatEmail: ""
        };
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.klient)) {
            if (this.props.klient.zdjeciaSkany.length > 0) {
                let array = []
                for (let i = 0; i < this.props.klient.zdjeciaSkany.length; i++) {
                    array.push(
                        {
                            src: 'data:image/jpg;base64,' + this.props.klient.zdjeciaSkany[i].dane,
                            alt: this.props.klient.zdjeciaSkany[i].nazwa
                        }
                    )
                }
                this.setState({images: array})
            }
            this.setState({documents: this.props.klient.dokumentySkany})
        }

    }

    onClickEdytuj() {
        this.props.handleClickEdytuj()
    }

    renderWaznyDo(value) {
        if (Boolean(value)) {
            if (DateAndTimeFormat.formatYYYYMMDD(moment()) > value) {
                return <span style={{color: 'firebrick'}}>{value} <i className={'fa fa-exclamation-circle'}></i></span>
            } else return value
        } else return ''
    }

    obliczWiek(pesel) {

        if (Boolean(pesel)) {
            if (pesel.length === 11) {
                let nowyear = new Date().toJSON().substr(0, 4)
                let nowmonth = new Date().toJSON().substr(5, 2)
                let nowday = new Date().toJSON().substr(8, 2)

                let wiek = 0;

                if (pesel[2] === '2' || pesel[2] === '3') {  // roczniki 2000
                    wiek = parseInt(nowyear) - parseInt('20' + pesel.substr(0, 2))

                    let peselmonth = pesel.substr(2, 2)
                    if (peselmonth[0] == '2') { // sty - wrze
                        if (parseInt('0' + peselmonth[1]) == parseInt(nowmonth)) {
                            if (parseInt(pesel.substr(4, 2)) > parseInt(nowday)) {
                                wiek = wiek - 1;
                            }
                        } else if (parseInt('0' + peselmonth[1]) > parseInt(nowmonth)) {
                            wiek = wiek - 1;
                        }
                    } else {   // peselmonth[0] == '3' - pazdz, list, gru
                        if (parseInt('1' + peselmonth[1]) == parseInt(nowmonth)) {
                            if (parseInt(pesel.substr(4, 2)) > parseInt(nowday)) {
                                wiek = wiek - 1;
                            }
                        } else if (parseInt('1' + peselmonth[1]) > parseInt(nowmonth)) {
                            wiek = wiek - 1;
                        }
                    }
                } else {   // roczniki 1900
                    wiek = parseInt(nowyear) - parseInt('19' + pesel.substr(0, 2))
                    if (parseInt(pesel.substr(2, 2)) == parseInt(nowmonth)) {
                        if (parseInt(pesel.substr(4, 2)) > parseInt(nowday)) {
                            wiek = wiek - 1;
                        }
                    } else if (parseInt(pesel.substr(2, 2)) > parseInt(nowmonth)) {
                        wiek = wiek - 1;
                    }

                }

                return wiek
            }
        }

    }

    render() {

        return (
            <div>

                <div style={{marginTop: '15px'}}>
                    <div className={'thumbnail'} style={{padding: '15px'}}>
                        <div style={{position: 'absolute', top: '30px', right: '30px', zIndex: '1'}}>
                            <TopButtonPointEdit onClick={this.onClickEdytuj} titleContent={'Edytuj dane klienta'}/>
                        </div>
                        <Row>
                            <Col xs={12} lg={3}>
                                <div className={'thumbnail'} style={{marginBottom: 0}}>
                                    {
                                        Boolean(this.props.klient.zdjecieProfilowe) ?
                                            <img
                                                src={'data:image/jpg;base64,' + this.props.klient.zdjecieProfilowe.dane}
                                                className={'img-ressponsive'}/>
                                            :
                                            <div>
                                                <p style={{textAlign: 'center', padding: '100px 0', color: '#f0ad4e'}}>
                                                    <i className={'fa fa-exclamation-circle'}></i> Brak zdjęcia
                                                </p>
                                            </div>
                                    }
                                </div>
                            </Col>
                            <Col xs={12} lg={4}>
                                <p style={{marginTop: '15px', fontStyle: 'italic', color: 'grey'}}>
                                    Dane o kliencie:
                                </p>
                                <p>
                                    <span><i className={'fa fa-id-badge'}></i> Identyfikator ID:</span>
                                    <span className={'label label-ebus-primary'}
                                          style={{marginLeft: '5px'}}>{this.props.klient.idKl}</span>
                                </p>
                                <p>
                                    <span><i className={'fa fa-user'}></i> Imie i nazwisko:</span>
                                    <label>
                                        {Boolean(this.props.klient.imie) ? this.props.klient.imie + " " : ' -'}
                                        {Boolean(this.props.klient.nazwisko) ? this.props.klient.nazwisko : ''}
                                    </label>
                                </p>
                                {/*<p>
                                    <span><i className={'fa fa-id-card-o'}></i> Nr Pesel:</span>
                                    <label>{Boolean(this.props.klient.pesel) ? this.props.klient.pesel : '-'}</label>
                                    {
                                        Boolean(this.props.klient.pesel) ?
                                        <TopIf isTrue={this.props.klient.pesel.length===11}>
                                            , {this.obliczWiek(this.props.klient.pesel)} lat
                                        </TopIf>
                                        :''
                                    }
                                </p>*/}
                                <p>
                                    <span><i className={'fa fa-phone'}></i> Telefon:</span>
                                    <label>{Boolean(this.props.klient.nrTel) ? this.props.klient.nrTel : '-'}</label>
                                </p>
                                <p>
                                    <span><i className={'fa fa-envelope'}></i> Email:</span>
                                    <label style={{
                                        display: 'inline-block',
                                        color: "dodgerblue",
                                        textDecoration: "underline",
                                        cursor: "pointer"
                                    }}
                                           onClick={() => {
                                               if (this.props.klient.email) {
                                                   this.setState({
                                                       pokazPopupWyslijEmail: true,
                                                       adresatEmail: this.props.klient.email
                                                   })
                                               }
                                           }}>{Boolean(this.props.klient.email) ? this.props.klient.email : '-'}</label>
                                </p>
                                <p>
                                    <span><i className={'fa fa-map-marker'}></i> Adres:</span>
                                    <label>
                                        {Boolean(this.props.klient.ulica) ? this.props.klient.ulica + ' ' : ''}
                                        {Boolean(this.props.klient.nrDomu) ? this.props.klient.nrDomu : ''}
                                        {Boolean(this.props.klient.nrMieszk) ? '/' + this.props.klient.nrMieszk + ', ' : ', '}
                                        {Boolean(this.props.klient.miejscowosc) ? this.props.klient.miejscowosc + ' ' : ''}
                                        {Boolean(this.props.klient.kodPoczt) ? this.props.klient.kodPoczt : ''}
                                        {!(Boolean(this.props.klient.ulica) || Boolean(this.props.klient.nrDomu) || Boolean(this.props.klient.miejscowosc) || Boolean(this.props.klient.kodPoczt)) ? '-' : ''}

                                    </label>
                                </p>
                            </Col>
                            <Col xs={12} lg={5}>
                                <p style={{marginTop: '15px', fontStyle: 'italic', color: 'grey'}}>
                                    Dokument uprawniający do ulgi:
                                </p>
                                <p>
                                    <span><i className={'fa fa-id-card'}></i> Numer:</span>
                                    <label>{this.props.klient.nrDok}</label>
                                </p>
                                <p>
                                    <span><i className={'fa fa-calendar'}></i> Ważny do:</span>
                                    <label>{this.renderWaznyDo(this.props.klient.nrDokWaznyDo)}</label>
                                </p>
                                <p>
                                    {Boolean(this.props.klient.dataUrodzenia) ? <span><i
                                            className={'fa fa-calendar'}></i> Data urodzenia:<label>{this.props.klient.dataUrodzenia}</label></span>
                                        :
                                        <div><label><i className={'fa fa-times'} style={{color: 'firebrick'}}></i> Brak
                                            daty urodzenia</label></div>}
                                </p>
                                <p>
                                    {Boolean(this.props.klient.nrDokSprawdzony) ?
                                        <div><label><i className={'fa fa-check'}
                                                       style={{color: 'forestgreen'}}></i> Potwierdzony</label></div>
                                        :
                                        <div><label><i className={'fa fa-times'} style={{color: 'firebrick'}}></i> Brak
                                            weryfikacji</label></div>
                                    }
                                </p>
                                <div>
                                    <TopIf isTrue={this.state.images.length > 0}><TopAlertInformacja
                                        text={'Zdjęcia - kliknij na miniaturę aby powiększyć'}/></TopIf>
                                    {
                                        this.state.images.map(item => {
                                            return <div className={'thumbnail'}
                                                        style={{
                                                            display: 'inline-block',
                                                            width: '100px',
                                                            margin: '5px',
                                                            cursor: 'pointer'
                                                        }}>
                                                <img src={item.src} onClick={() => this.setState({visible: true})}/>
                                            </div>
                                        })
                                    }
                                </div>
                                <div>
                                    <TopIf isTrue={this.state.documents.length > 0}><TopAlertInformacja
                                        text={'Dokumenty - kliknij aby pobrać'}/></TopIf>
                                    {
                                        this.state.documents.map(item => {
                                            return (<span
                                                onClick={() => DownloadUtilities.pobierzPlik(item.dane, item.typ, item.nazwa)}
                                                title={'Kliknij aby pobrać'}
                                                style={{
                                                    cursor: 'pointer',
                                                    marginRight: '5px',
                                                    marginBottom: '5px',
                                                    display: 'inline-block'
                                                }}
                                                className={'label label-ebus-default'}>
                                                    <i className={OthersUtilities.renderFileIcon(item.typ)}
                                                       style={{marginRight: '5px'}}></i>
                                                    <span>{item.nazwa}</span>
                                                    </span>)
                                        })
                                    }
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                <Viewer
                    visible={this.state.visible}
                    onClose={() => {
                        this.setState({visible: false});
                    }}
                    images={this.state.images}
                />
                {
                    (this.state.pokazPopupWyslijEmail) ?
                        <WyslijMailDoKlientaPopup adresat={this.state.adresatEmail}
                                                  onClickZamknij={() => this.setState({
                                                      pokazPopupWyslijEmail: false,
                                                      adresatEmail: ""
                                                  })}/>
                        : ""
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/stronaKlienta/components/StronaKlientaDane.js